/*FLAG SORTING */
$(document).ready(function async() {
    if (shoptet.abilities.about.generation === 3) {
        $(".flag-action").text("Výhodná nabídka");
        flags_detail();
        flags_cat();
    }
});
document.addEventListener("dmproductsDone", function () {
    if (shoptet.abilities.about.generation === 3) {
        flags_cat();
    }
});
document.addEventListener("ShoptetDOMContentLoaded", function () {
    if (shoptet.abilities.about.generation === 3) {
        flags_cat();
    }
});
function flagOrder(flagElement) {
    var flag_class = flagElement.attr("class");

    var storedValue = sessionStorage.getItem(flag_class);
    // Pokud existuje
    if (storedValue !== null) {
        flagElement.css("order", storedValue);
    }
    // Pokud neexistuje
    else {
        var flags_plus_count = 0;
        // Jupiter + Venus fix
        var jupiter = $(".jupiter").length;
        var venus = $(".venus").length;
        if (jupiter || venus) {
            var shop_lang = getShoptetDataLayer().language;
            if (jupiter) {
                if (flag_class.includes("flag-sleva")) {
                    if (["cs", "sk"].includes(shop_lang)) {
                        flags_plus_count = 6;
                    } else if (["hu", "en", "ro"].includes(shop_lang)) {
                        flags_plus_count = 9;
                    } else if (["pl", "de"].includes(shop_lang)) {
                        flags_plus_count = 7;
                    }
                }
            } else if (venus) {
                if (flag_class.includes("flag-discount")) {
                    if (shop_lang === "cs") {
                        flags_plus_count = 5;
                    } else if (["sk", "hu", "ro", "pl"].includes(shop_lang)) {
                        flags_plus_count = 6;
                    } else if (["en"].includes(shop_lang)) {
                        flags_plus_count = 7;
                    }
                }
            }
        }
        var flag_char = flagElement.text().trim().length + flags_plus_count;
        sessionStorage.setItem(flag_class, "-" + flag_char);
        flagElement.css("order", "-" + flag_char);
    }
}
function flags_detail() {
    if (getShoptetDataLayer().pageType === "productDetail") {
        var template_id = Number(shoptet.abilities.about.id);
        var flags_selector = ".p-detail-inner";
        // Classic
        if (template_id === 11) {
            flags_selector = ".product-top";
        }
        $(flags_selector)
            .find(".flags-default .flag")
            .each(function () {
                flagOrder($(this));
            });

        $(flags_selector).find(".flags-default").css("opacity", 1);
    }
}
function flags_cat() {
    $(".product .flags-default .flag:not(.flagdone)").each(function () {
        flagOrder($(this));
        $(this).addClass("flagdone");
    });
    $(".product .flags-default").css("opacity", 1);
}